module.exports = __webpack_public_path__ + "img/minerva_nova.ef0362ed.png";